module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/transbanklogo.4e55d4d6.svg";